
import { useEffect, useState, useRef } from 'react';

const StatisticsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const stats = [
    {
      icon: 'ri-user-smile-line',
      number: 5000,
      suffix: '+',
      label: 'عميل راضٍ',
    },
    {
      icon: 'ri-car-line',
      number: 12000,
      suffix: '+',
      label: 'رحلة ناجحة',
    },
    {
      icon: 'ri-star-fill',
      number: 98,
      suffix: '%',
      label: 'نسبة الرضا',
    },
    {
      icon: 'ri-calendar-line',
      number: 8,
      suffix: '+',
      label: 'سنوات خبرة',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const CountUp = ({ end, suffix }: { end: number; suffix: string }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!isVisible) return;

      let startTime: number;
      const duration = 2000;

      const animate = (currentTime: number) => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);
        
        setCount(Math.floor(progress * end));

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    }, [isVisible, end]);

    return (
      <span>
        {count.toLocaleString('ar-SA')}
        {suffix}
      </span>
    );
  };

  return (
    <section
      id="statistics"
      ref={sectionRef}
      className="py-20 bg-gradient-to-l from-gold via-gold to-gold-dark"
    >
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center relative group"
            >
              {/* Divider */}
              {index < stats.length - 1 && (
                <div className="hidden lg:block absolute left-0 top-1/2 -translate-y-1/2 w-px h-24 bg-luxury-black/20"></div>
              )}

              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-luxury-black/10 rounded-full group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-luxury-black text-3xl`}></i>
              </div>

              {/* Number */}
              <div className="font-almarai font-black text-6xl text-luxury-black mb-2">
                <CountUp end={stat.number} suffix={stat.suffix} />
              </div>

              {/* Label */}
              <p className="font-cairo font-semibold text-xl text-luxury-black">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;
